import { UserModuleRole } from './admin-console.models';

/** `ModuleConstants.CRM` on the API. ERP Super Admin never covers this module; its role is given on its own. */
export const CRM_MODULE_ID = '2a8e0b92-0067-470a-91a4-bcb60810371b';

export function isCrmModule(moduleId: string | null | undefined): boolean {
  return moduleId?.toLowerCase() === CRM_MODULE_ID;
}

/** An ERP admin is SuperAdmin on at least one ERP module; a CRM role alone opens nothing in the ERP. */
export function isErpAdmin(userModuleRoles: UserModuleRole[] | null | undefined): boolean {
  return (userModuleRoles ?? []).some(
    ({ module, role }) => role?.roleName === 'SuperAdmin' && !isCrmModule(module?.moduleId)
  );
}

/** A CRM-only user has a CRM role and nothing in the ERP, so after sign-in they go straight on to the CRM. */
export function isCrmOnlyUser(userModuleRoles: UserModuleRole[] | null | undefined): boolean {
  const roles = userModuleRoles ?? [];
  return roles.length > 0 && roles.every(({ module }) => isCrmModule(module?.moduleId));
}
